export default "__VITE_ASSET__CeqNlQOP__"